import { useEffect, useState } from "react"

function ChildComponent({ props, previousPage, flag }) {
    const esempiSottoTTL = [
        {
            tipo: "Autoraduno",
            text: "▪ Scaldate i motori: il raduno sta arrivando! 🏁"
        },
        {
            tipo: "Autoraduno",
            text: "▪ Non è solo una parata, è il richiamo della strada. Ti aspettiamo il [Data] per una giornata dedicata alla potenza, allo stile e al sound che amiamo."
        },
        {
            tipo: "Autoraduno",
            text: "▪ Siamo lieti di invitare tutti i possessori di vetture storiche e di interesse collezionistico al raduno che si terrà il [Data]. Un percorso panoramico tra le bellezze di [Nome zona].",
        },
        {
            tipo: "Carnevale",
            text: "▪ 🎭 Il Carnevale è arrivato ed è ora di far festa!. Non dimenticare il costume. A chiacchiere e frittelle pensiamo noi... tu porta solo la voglia di far baccano!"
        },
        {
            tipo: "Carnevale",
            text: "▪ Un Carnevale... fuori di testa! 💘🎭 Quest'anno l'amore si maschera! Che tu sia in coppia o in cerca della tua metà, l'importante è brillare sotto i coriandoli."
        },
        {
            tipo: "Concerto",
            text: "▪ Volume a 11 e luci spente: il live che aspettavi! ⚡ I [Nome Band] salgono sul palco del [Nome Locale] per una serata di pura adrenalina. Solo musica vera, sudore e distorsione."
        },
        {
            tipo: "Concerto",
            text: "▪ Note, parole e atmosfera. ✨Ti invitiamo a una serata speciale presso [Luogo]. Un viaggio musicale attraverso i brani di [Nome Artista] per un'esperienza immersiva e intima."
        },
        {
            tipo: "Concerto",
            text: "▪ THE BEAT GOES ON! 🔊🕺 Pronti per il party dell'anno? Il sound di [Nome DJ/Band] conquisterà il [Nome Club]. Con la [Genere Musicale] non smetteremo di ballare fino all'alba."
        },
        {
            tipo: "Cultura",
            text: "▪ Cultura in movimento: vivi l'emozione, immergiti, ispirati, ignora la routine. Un viaggio oltre il visibile."
        },
        {
            tipo: "Cultura",
            text: "▪ Uniamo le storie, intrecciamo culture. Insieme per scoprire, uniti per creare."
        },
        {
            tipo: "Enogastronomico",
            text: "▪ Non è solo un evento, è un viaggio sensoriale tra eccellenze locali: Scopri l'arte degli abbinamenti tra i nostri vini e i piatti della tradizione con i nostri sommelier esperti.",
        },
        {
            tipo: "Enogastronomico",
            text: "▪ Vivi l'atmosfera, assapora la qualità, riscopri la tradizione dei prodotti tipici e dei vini locali. Più che un evento è un salto nel tempo. Salva la data.",
        },
        {
            tipo: "Enogastronomico",
            text: "▪ Assapora l'eccellenza: scopri il menù del nostro evento esclusivo [nome dell'evento]. Il gusto autentico delle feste...prenota ora!"
        },
        {
            tipo: "Enogastronomico",
            text: "▪ Assapora l'essenza del territorio, calice dopo calice. Un viaggio sensoriale tra i sapori che hanno fatto la storia."
        },
        {
            tipo: "Enogastronomico",
            text: "▪ Dove la tradizione incontra l'innovazione in un unico sorso. Food, Wine & Good Vibes."
        },
        {
            tipo: "Enogastronomico",
            text: "▪ Eccellenze locali: il meglio della nostra terra nel tuo piatto. La festa del [Nome Prodotto]: l'orgoglio del territorio in degustazione."
        },
        {
            tipo: "Enogastronomico",
            text: "▪ Ridefinire il cibo: dove il design incontra la forchetta. Non solo cibo, ma un'esperienza che ti farà sentire parte di qualcosa di grande."
        },
        {
            tipo: "Festa",
            text: "▪ Lasciati avvolgere dalla magia delle feste e dai sapori autentici della nostra terra che apre le sue porte con stand e musica live.",
        },
        {
            tipo: "Festa",
            text: "▪ Non mancare: il divertimento è garantito. Un'esperienza che ti farà sentire parte di qualcosa di grande."
        },
        {
            tipo: "Festa",
            text: "▪ Unisciti a noi: l'energia è contagiosa. Preparati a saltare, cantare e ballare!"
        },
        {
            tipo: "Festa",
            text: "▪ Abbiamo voglia di staccare la spina e abbiamo deciso che il miglior modo per farlo è insieme a voi. Niente scuse, solo buona musica, drink ghiacciati e l'atmosfera giusta."
        },
        {
            tipo: "Festa",
            text: "▪ Stiamo organizzando una serata epica e non puoi mancare! Niente di formale, solo il piacere di stare insieme e goderci la serata."
        },
        {
            tipo: "Fiera",
            text: "▪ Il punto d'incontro per i professionisti torna a [Location]. Un'occasione unica per scoprire le ultime tecnologie, incontrare i leader del mercato e ampliare la propria rete di contatti.."
        },
        {
            tipo: "Fiera",
            text: "▪ Scopri, Ispira, Crea✨ Passa una giornata diversa tra stand creativi, novità incredibili e workshop pratici. Che tu sia un appassionato di [Tema] o in cerca di ispirazione, questa è la fiera che fa per te!"
        },
        {
            tipo: "Meeting",
            text: "▪ Le nuove frontiere della tecnologia e il futuro del lavoro. Strategie concrete per un impatto ambientale positivo."
        },
        {
            tipo: "Meeting",
            text: "▪ Rinascita urbana. Un progetto di rigenerazione che ridà vita al quartiere."
        },
        {
            tipo: "Mercatino",
            text: "▪ Il fascino dell'unico: ti aspettiamo al Mercatino Creativo! ✨"
        },
        {
            tipo: "Mercatino",
            text: "▪ Dimentica i prodotti in serie. Vieni a scoprire il talento dei nostri artigiani: gioielli fatti a mano, decorazioni per la casa, illustrazioni e creazioni uniche che raccontano una storia."
        },
        {
            tipo: "Mercatino",
            text: "▪ Torna l'appuntamento con il Mercatino del Vintage e dell'Usato. Tra vinili, abbigliamento retrò, libri ingialliti e piccoli pezzi di antiquariato, il pezzo mancante della tua collezione ti sta aspettando."
        },
        {
            tipo: "Motoraduno",
            text: "▪ Non importa cosa guidi, conta quanta strada hai sotto le ruote. Ti aspettiamo il [Data] per una giornata di curve, paesaggi mozzafiato e ottima compagnia."
        },
        {
            tipo: "Motoraduno",
            text: "▪ Sound, Asfalto e Adrenalina. 🏁🔥"
        },
        {
            tipo: "Motoraduno",
            text: "▪ È ora di tirare fuori la tua belva dal garage. Sabato [Data] ci ritroviamo per il [Nome Evento]. Un evento dedicato a chi vive per il brivido di una curva perfetta e il rombo dei motori."
        },
        {
            tipo: "Mostra",
            text: "▪ Siamo lieti di invitarvi al vernissage della mostra di [Nome Artista]. Un'esplorazione visiva che indaga il rapporto tra [Elemento A] e [Elemento B] attraverso opere inedite e installazioni immersive."
        },
        {
            tipo: "Mostra",
            text: "▪ Cosa si nasconde dietro un'immagine? Venite a scoprirlo in una mostra che sfida la percezione. [Nome Artista] cattura l'essenza di [Soggetto] in una serie di scatti/opere che tolgono il fiato."
        },
        {
            tipo: "Mostra",
            text: "▪ Un percorso espositivo unico che raccoglie [Oggetti/Documenti] provenienti da [Origine]. Una testimonianza preziosa per comprendere [Contesto Storico/Culturale] e riscoprire le radici di [Luogo/Tema]."
        },
        {
            tipo: "Mostra",
            text: "▪ Oltre lo sguardo: scopri [Titolo Mostra] ✨"
        },
        {
            tipo: "Mostra",
            text: "▪ [Titolo Mostra]: Un viaggio tra [Tema/Stile] 🖼️"
        },
        {
            tipo: "Mostra",
            text: "▪ [Titolo Evento]: Memoria e Bellezza 📜"
        },
        {
            tipo: "Notte bianca",
            text: "▪ Quando il sole tramonta, la città si accende! ✨"
        },
        {
            tipo: "Notte bianca",
            text: "▪ Preparati per la notte più lunga dell'anno. Il [Data] [Nome Città] si trasforma in un palcoscenico a cielo aperto. Shopping sotto le stelle, concerti in ogni piazza, musei aperti e tutto il gusto dello street food locale.."
        },
        {
            tipo: "Notte bianca",
            text: "▪ [Nome Città] Notte Bianca: Il Suono della Notte 🔊🌙"
        },
        {
            tipo: "Notte bianca",
            text: "▪ Una maratona di arte e musica che attraverserà ogni vicolo. Dalle ore [Ora], lasciati guidare dalle luci e dalle note. Dai palchi principali alle performance acustiche più intime, la città diventerà un'esplosione di creatività."
        },
        {
            tipo: "Presepe",
            text: "▪ Rivivi la magia della Notte Santa. Luci, sogni e tradizioni: il vero spirito del Natale."
        },
        {
            tipo: "Sagra",
            text: "▪ Il sapore autentico di una volta ti aspetta a [Nome Località]. Un weekend dedicato alla scoperta del [Nome Prodotto], preparato secondo le ricette segrete delle nostre nonne."
        },
        {
            tipo: "Sagra",
            text: "▪ Non chiamatela solo Sagra: arriva il [Nome Evento]! 🍻🔥"
        },
        {
            tipo: "Sagra",
            text: "▪ Due giorni di fiumi di birra, street food locale e musica che non ti fa stare seduto. Se cerchi il mix perfetto tra buona cucina e divertimento, il posto giusto è [Luogo]."
        },
        {
            tipo: "Sagra",
            text: "▪ Vieni a riscoprire l'autenticità della nostra terra. Da [Data] a [Data], il borgo di [Luogo] si trasforma in una cucina a cielo aperto per celebrare il [Prodotto], tra ricette tramandate e ospitalità contadina."
        },
        {
            tipo: "Sagra",
            text: "▪ Metti in pausa la dieta: la festa più attesa dell'anno è tornata! Ti aspettiamo a [Luogo] per un weekend di fiumi di [Birra/Vino], specialità alla brace e musica dal vivo che ti farà ballare fino a tardi."
        },
        {
            tipo: "Sagra",
            text: "▪ Sagra del [Nome]: Pancia piena e cuore felice! 🔥🎸"
        },
        {
            tipo: "Sagra",
            text: "▪ Sapori di una volta: Ti aspettiamo alla Sagra del [Nome Prodotto]! 🌽🍷"
        },
    ]
    const [formData, setFormData] = useState({ tipo: '' })
    const [msg, setMsg] = useState({ cerca: null })

    function esempioCliccato(e) {
        props(e.slice(2))
    }
    function handleChange(e) {
        const { value } = e.target//attributi degli input
        setFormData({ ...formData, tipo: value })
    }

    useEffect(() => {
        const x = esempiSottoTTL.filter(e => e.tipo.toUpperCase().includes(formData.tipo.toUpperCase()))
        if (x.length === 0) {
            setMsg({ cerca: 'Nessun esempio trovato' })
        }
        else setMsg({ cerca: null })
    }, [formData.tipo])

    return (<>
        <div className={`divNotifiche${flag === 'esempiSottotitoli' ? 'Aperto' : ''}`} id="esempi" style={{ marginTop: '-4em', height: '100%', padding: '3px' }}>
            <div style={{ margin: '0 0 0 5px', fontSize: 'xx-large', cursor: 'pointer' }}
                 onClick={() => { window.history.back() }}>◀
            </div>

            <div className='p-1'>
                <input className="fw-bold rounded form-control"
                    style={{ border: '1px solid blue' }}
                    name='regione'
                    onChange={handleChange}
                    maxLength={30}
                    placeholder='Cerca per tipo es. Carnevale'
                    type='text' />
            </div>

            <div className="mt-1 p-1 text-center" style={{ opacity: '.6' }}><i>{msg.cerca}</i></div>

            <div style={{ margin: '1em 3px', overflowY: 'scroll', height: '80%' }}>
                {esempiSottoTTL
                    .filter(e => e.tipo.toUpperCase().includes(formData.tipo.toUpperCase()) === true)
                    .map((elem, index) => {
                        return (
                            <div className="form-control" style={{ cursor: 'pointer', border: '2px solid paleturquoise' }}
                                key={`${index}sot`}
                                onClick={() => { esempioCliccato(elem.text) }}>
                                <p style={{ fontWeight: '600', fontSize: 'small' }}>{elem.tipo}</p>
                                {elem.text}<span style={{ backgroundColor: 'black', color: 'white', fontSize: 'small', padding: '0 3px' }}>copia</span>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    </>
    )
}

export default ChildComponent